export enum LabelFlyTo {
    Object = 'object',
    Position = 'position'
}
